import { Box } from "../../components/Box";
import { Flex } from "../../components/Flex";
import { Paragraph } from "../../components/Paragraph";
import { IndividualDetails } from "../../types/Individual";
import { CheckHeading, CheckParagraph } from "./CheckStyledComponents";
import { H3 } from "../../components/Heading";
import { capitalise } from "../../utils/string";

type Props = {
  data: IndividualDetails;
};

const CardLine = ({ children, ...styleProps }: any) => (
  <Paragraph fontSize={2} color="gray.60" my={0} {...styleProps}>
    {children}
  </Paragraph>
);

export const AddressIndividualInformation = (props: Props) => {
  const { data } = props;

  const addressBlock = (
    <>
      <CardLine>
        {data?.address?.flat_appartment_subbuilding && (
          <span>
            {data?.address?.flat_appartment_subbuilding}
            &nbsp;
          </span>
        )}
        {data?.address?.building_number && (
          <span>
            {data?.address?.building_number}
            &nbsp;
          </span>
        )}
        {data?.address?.building_name && (
          <span>
            {data?.address?.building_name}
            &nbsp;
          </span>
        )}
        {data?.address?.road_street}
      </CardLine>
      <CardLine>
        {data?.address?.town_city && (
          <span>
            {data?.address?.town_city}
            &nbsp;
          </span>
        )}
        {data?.address?.district}
      </CardLine>
      <CardLine>{data?.address?.post_zip_code}</CardLine>
      <CardLine>{data?.address?.country_name}</CardLine>
    </>
  );
  return (
    
      <Box mb={3}>
        <H3 mb={0}>Individual Information</H3>
        <Paragraph mt={0} fontSize={1} color={"gray.60"}>
          Individual details used for address verification
        </Paragraph>

        <Flex alignItems="center">
          <CheckHeading minWidth={200}>First Name:</CheckHeading>
          <CheckParagraph>
            {data?.personal_detail?.first_name
              ? capitalise(data?.personal_detail?.first_name)
              : "-"}
          </CheckParagraph>
        </Flex>
        <Flex alignItems="center">
          <CheckHeading minWidth={200}>Middle Name(s):</CheckHeading>

          <CheckParagraph>
            {data?.personal_detail?.middle_name
              ? capitalise(data?.personal_detail?.middle_name)
              : "-"}
          </CheckParagraph>
        </Flex>
        <Flex alignItems="center">
          <CheckHeading minWidth={200}>Surname:</CheckHeading>
          <CheckParagraph>
            {data?.personal_detail?.last_name
              ? capitalise(data?.personal_detail?.last_name)
              : "-"}
          </CheckParagraph>
        </Flex>
        <Flex alignItems="center">
          <CheckHeading minWidth={200}>Date Of Birth:</CheckHeading>
          <CheckParagraph>
            {data?.personal_detail?.date_of_birth
              ? data?.personal_detail?.date_of_birth
              : "-"}
          </CheckParagraph>
        </Flex>
        <Flex alignItems="center">
          <CheckHeading minWidth={200}>Sex:</CheckHeading>
          <CheckParagraph>
            {data?.personal_detail?.gender
              ? capitalise(data?.personal_detail?.gender)
              : "-"}
          </CheckParagraph>
        </Flex>
        <Flex>
          <CheckHeading minWidth={200}>Address:</CheckHeading>
          <Box>{data?.address ? addressBlock : "-"}</Box>
        </Flex>
      </Box>
  );
};
